exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom {\n  margin-top: 27px; }\n\n.panel {\n  box-shadow: none; }\n\n.added-block {\n  padding: 5px 0px; }\n\n.plus {\n  margin-top: 5px; }\n\n.s-n-btn {\n  margin-right: 1.3em; }\n\n.img-thumbnail {\n  border: 0 !important;\n  padding: 0;\n  border-radius: 0; }\n\n.img-width {\n  max-width: 30%; }\n\ninput[type=\"file\"] {\n  display: block;\n  color: transparent; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/sooweeseng/Documents/Ionic Apps/ShunFa/ShunFa-Restaurant Backend/Restaurant_Firebasebackend/webapp/src/app/routes/restaurant/menu-items/edit-item/edit-item.component.scss
// module id = ../../../../../src/app/routes/restaurant/menu-items/edit-item/edit-item.component.scss
// module chunks = main